import _ from 'lodash';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
const $ = require('jquery');
import 'jquery-ui';
import IMask from 'imask';
import { gsap } from "gsap";
import EmblaCarousel from 'embla-carousel';
import { setupProgressBar } from './js/shared/EmblaCarouselProgressBar';
import { addPrevNextBtnsClickHandlers } from './js/shared/EmblaCarouselArrowButtons';

import "./styles.scss";

import "./js/shared/pageComponents";
import "./js/shared/loadAssets";
import "./js/shared/formHandling";
import "./js/shared/cookies";
import "./js/pages/header";
import "./js/pages/frontPage";
// import "./js/landing-pages/landingPageLayout";
// import "./js/landing-pages/landingPageForm";


const OPTIONS = {
  loop: true,
  dragFree: false,
  active: true,
  breakpoints: {
    // '(min-width: 768px)': { active: false }
  }
}

const emblaNode = document.querySelector('.embla')
if ( emblaNode ) {
  const viewportNode = emblaNode.querySelector('.embla__viewport')
  const prevBtn = emblaNode.querySelector('.embla__button--prev')
  const nextBtn = emblaNode.querySelector('.embla__button--next')
  const progressNode = emblaNode.querySelector('.embla__progress__bar')

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS)
  const { applyProgress, removeProgress } = setupProgressBar(
    emblaApi,
    progressNode
  )

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApi,
    prevBtn,
    nextBtn
  )

  emblaApi
    .on('init', applyProgress)
    .on('reInit', applyProgress)
    .on('scroll', applyProgress)
    .on('slideFocus', applyProgress)
    .on('destroy', removeProgress)
    .on('destroy', removePrevNextBtnsClickHandlers)

}
